import React, { useEffect } from "react";
import { Route, Redirect, Switch, BrowserRouter } from "react-router-dom";
import Home from "./components/home";
import Thanks from "./components/thanks";
import { getLocation } from "./services/locationService";
import { vars } from "./utils/variables";

function App() {
  useEffect(() => {
    checkLocation();
  }, []);

  const getQueryStringValue = (key) => {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  };

  const checkLocation = async () => {
    if (getQueryStringValue("testing") !== "") return;
    const { data } = await getLocation();
    const country = data.country;
    console.log(country);
    if (
      (!vars("isInternational") && country !== "AR") ||
      (vars("isInternational") &&
        getQueryStringValue("canalID") !== "" &&
        getQueryStringValue("canalID").substr(
          getQueryStringValue("canalID").length - 1
        ) !== "e")
    ) {
      let redirectUrl = "/cocina-saludable/exterior";
      const canalId = getQueryStringValue("canalID");
      if (canalId !== "") redirectUrl += "?canalID=" + canalId + "e";
      window.location.assign(redirectUrl);
    }
    if (
      (vars("isInternational") && country === "AR") ||
      (!vars("isInternational") &&
        getQueryStringValue("canalID") !== "" &&
        getQueryStringValue("canalID").substr(
          getQueryStringValue("canalID").length - 1
        ) === "e")
    ) {
      let redirectUrl = "/cocina-saludable/";
      const canalId = getQueryStringValue("canalID");
      if (canalId !== "")
        redirectUrl +=
          "?canalID=" +
          canalId.substr(0, getQueryStringValue("canalID").length - 1);
      window.location.assign(redirectUrl);
    }
  };

  return (
    <React.Fragment>
      <BrowserRouter>
        <Switch>
          <Route path="/gracias" component={Thanks} />
          <Route path="/cocina-saludable/gracias" component={Thanks} />
          <Route path="/cocina-saludable/exterior" component={Home} />
          <Route path="/" component={Home} />

          <Redirect to="/not-found" />
        </Switch>
      </BrowserRouter>
      <footer className="black">
        <div className="container">
          <div className="row">
            <div className="col-md-5 mt-4 d-none d-md-block d-lg-block">
              <p>
                <strong>Visita nuestro sitio web: </strong>
                <br />
                <a
                  className="sitioweb"
                  target="_blank"
                  href="https://www.selecciones.com.ar"
                >
                  https://www.selecciones.com.ar
                </a>
              </p>
              <p>
                <strong>¿Necesitas ayuda? </strong>
                <br />
                <a href="https://wa.me/5491162873348" target="_blank">
                  Contactate con nosotros <i className="fa fa-whatsapp"></i>
                </a>
              </p>
              <p className="copyright">
                Copyright 2020-2021 One Minetta Media SA
              </p>
            </div>
            <div className="col-md-7 text-right mt-4 legales d-none d-md-block  d-lg-block">
              <a href="https://www.facebook.com/sabordecasa.ar" target="_blank">
                <img src="https://www.selecciones.com.ar/img/landings/landing-85/fb.png" />
              </a>
              <a
                href="https://www.instagram.com/sabordecasa.ar/"
                target="_blank"
              >
                <img src="https://www.selecciones.com.ar/img/landings/landing-85/ig.png" />
              </a>
              <br />
              <br />
              <br />
              <br />
              <p>
                <a
                  href="https://www.selecciones.com.ar/institucional/legales-de-venta-cocina-saludable"
                  target="_blank"
                >
                  Política de venta |
                </a>
                <a
                  href="https://www.sabordecasa.com.ar/protecciondatos"
                  target="_blank"
                >
                  Política de Protección de datos personales |
                </a>
                <a
                  href="https://www.sabordecasa.com.ar/terminos"
                  target="_blank"
                >
                  Términos y Condiciones
                </a>
              </p>
            </div>

            <div className="col-md-6 mt-4 text-center d-none d-block d-sm-block d-md-none">
              <p>
                <strong>
                  Visita nuestro sitio web: <br />
                </strong>
                <a
                  className="sitioweb"
                  target="_blank"
                  href="https://www.selecciones.com.ar"
                >
                  https://www.selecciones.com.ar
                </a>
              </p>
              <p>
                <strong>¿Necesitas ayuda? </strong>
                <br />
                <a href="https://wa.me/5491162873348" target="_blank">
                  Contactate con nosotros <i className="fa fa-whatsapp"></i>
                </a>
              </p>
              <a href="https://www.facebook.com/sabordecasa.ar" target="_blank">
                <img src="https://www.selecciones.com.ar/img/landings/landing-85/fb.png" />
              </a>
              <a
                href="https://www.instagram.com/sabordecasa.ar/"
                target="_blank"
              >
                <img src="https://www.selecciones.com.ar/img/landings/landing-85/ig.png" />
              </a>
              <br />
              <br />
            </div>
            <div className="col-md-6 text-right mt-2 legales text-center d-none d-block d-sm-block d-md-none">
              <p>
                <a
                  href="https://www.selecciones.com.ar/institucional/legales-de-venta-cocina-saludable"
                  target="_blank"
                >
                  Política de venta |
                </a>
                <a
                  href="https://www.sabordecasa.com.ar/protecciondatos"
                  target="_blank"
                >
                  Política de Protección de datos personales |
                </a>
                <a
                  href="https://www.sabordecasa.com.ar/terminos"
                  target="_blank"
                >
                  Términos y Condiciones
                </a>
              </p>
              <p className="copyright">
                Copyright 2020-2021 One Minetta Media SA
              </p>
            </div>
          </div>
          {/*  <div class="row">
	        	<div class="col text-center">
	        		<p class="copyright">Copyright 2020-2021 One Minetta Media SA</p>
	        	</div>
	        </div> */}
        </div>
      </footer>
    </React.Fragment>
  );
}

export default App;
